/**
 * Background tint for status chips (same pattern as client-profiles DesktopAppointmentCard).
 */
export const hexToRgba = (hex, alpha) => {
  const h = String(hex || '').replace('#', '');
  const full = h.length === 3 ? [...h].map((c) => c + c).join('') : h;
  if (full.length !== 6) return `rgba(117, 117, 117, ${alpha})`;
  const num = parseInt(full, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
